export default __webpack_public_path__ + "static/media/review5.0aca2b29.jpg";